import {ForecastDetail} from './forecast-detail';

export class ForecastDetailCollection {
    private totalItems: number = 0;
    private forecastDetails: ForecastDetail[] = [];

    setTotalItems(totalItems: number) {
        this.totalItems = totalItems;
    }

    setForecastDetails(forecastDetails: ForecastDetail[]) {
        this.forecastDetails = forecastDetails;
    }

    getTotalItems(): number {
        return this.totalItems;
    }

    getForecastDetails(): ForecastDetail[] {
        return this.forecastDetails;
    }
}
